import { render, staticRenderFns } from "./AgentSilver.vue?vue&type=template&id=00977e81&scoped=true&lang=pug&"
import script from "./AgentSilver.vue?vue&type=script&lang=js&"
export * from "./AgentSilver.vue?vue&type=script&lang=js&"
import style0 from "./AgentSilver.vue?vue&type=style&index=0&id=00977e81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00977e81",
  null
  
)

export default component.exports